import { render, staticRenderFns } from "./autoResponder.vue?vue&type=template&id=2089f56a&scoped=true"
import script from "./autoResponder.vue?vue&type=script&lang=js"
export * from "./autoResponder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089f56a",
  null
  
)

export default component.exports